module.exports = __webpack_public_path__ + "static/media/construccion.4e63b30f.png";